module.exports = __webpack_public_path__ + "static/media/Dialga_gaussian2.500d41eb.png";